module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-3_BW2-p-130x130q80-d315986fdb7b10a31b5a8abd394b927a.jpg";